<script>
import Notification from "@/components/reUse/Notification.vue";

export default {
  name: "NastavitveCamo",
  components: {Notification},
  data() {
    return {
      camoti: [],
      searchUser: '',
      izbranUporabnik: null,
      izbranKljuc: null,
      ime: null,
      priimek: null,
      tel: null,
      email: null,
      jezik: null,
      geslo: null,
      pGeslo: null,
      sGesla: false,
      text: '',
      types: '',
      ShowNoti: false,
      brisanje: false,
      posodabljam: false,
      novVnos: false,
      vnos: false,
    }
  },
  mounted() {
    this.BeriCamote();
  },
  computed: {
    FilterUporabnikov() {
      if (this.searchUser !== '') {
        return this.camoti.filter(uporabnik =>
            uporabnik.ime.toLowerCase().includes(this.searchUser.toLowerCase()) ||
            uporabnik.priimek.toLowerCase().includes(this.searchUser.toLowerCase()));
      } else {
        return this.camoti;
      }
    },
  },
  methods: {
    BeriCamote() {
      axios.get('./api/camo/uporabniki/').then((response) => {
        this.camoti = response.data.podatki;
      }).catch((napaka) => {
        this.text = 'Prišlo je do napake';
        if(napaka.response.napaka) {
          this.text = napaka.response.napaka;
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.posodabljam = false;
      })
    },
    UrediUporabnika(id) {
      this.izbranUporabnik = id;
      for (let i = 0; i < this.camoti.length; i++) {
        if (this.camoti[i].id === id) {
          this.izbranKljuc = i;
          break;
        }
      }
      this.ime = this.camoti[this.izbranKljuc].ime;
      this.priimek = this.camoti[this.izbranKljuc].priimek;
      this.tel = this.camoti[this.izbranKljuc].tel;
      this.jezik = this.camoti[this.izbranKljuc].jezik;
      this.email = this.camoti[this.izbranKljuc].email;
    },
    BrisiUporabnika(id) {
      this.brisanje = true;
      this.izbranUporabnik = id;
      this.text = "Ste prepričani, da želite izbrisati uporabnika? Pozor! uporabnik ne bo več imel dostopa do aplikacije.";
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    Brisi() {
      let podatki = new URLSearchParams();
      podatki.append('uID', this.izbranUporabnik);
      let novicamoti = [];
      axios.post('./api/uporabniki/brisi/', podatki, {withCredentials: true}).then((response) => {
        this.brisanje = false;
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
        for (let i = 0; i < this.camoti.length; i++) {
          if (this.camoti[i].id !== this.izbranUporabnik) {
            novicamoti.push(this.camoti[i]);
          }
        }
        this.camoti = novicamoti;
        this.izbranUporabnik = null;
        this.brisanje = false;
      }).catch((napaka) => {
        this.brisanje = false;
        if (napaka !== undefined && napaka.response.data.napaka !== null) {
          this.text = napaka.response.data.napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        } else {
          this.text = napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        }

      });
    },
    Validate() {
      this.posodabljam = true;
      if (this.ime !== '' && this.priimek !== '' && this.tel !== '') {
        let podatki = new URLSearchParams();
        podatki.append('uID', this.izbranUporabnik);
        podatki.append('ime', this.ime);
        podatki.append('priimek', this.priimek);
        podatki.append('tel', this.tel);
        podatki.append('jezik', this.jezik);
        podatki.append('email', this.email);
        if(this.sGesla) {
          if(this.pGeslo === this.geslo) {
            podatki.append('geslo', this.geslo);
          }else {
            this.posodabljam = false;
            this.text = "Geslo in potrditveno geslo se ne ujemata.";
            this.types = "Napaka";
            this.ShowNoti = true;
            return;
          }
        }
        axios.post('./api/camo/uporabniki/uredi/', podatki, {withCredentials: true}).then((response) => {
          this.posodabljam = false;
          this.text = response.data.sporocilo;
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.camoti[this.izbranKljuc].ime = this.ime;
          this.camoti[this.izbranKljuc].priimek = this.priimek;
          this.camoti[this.izbranKljuc].tel = this.tel;
          this.camoti[this.izbranKljuc].jezik = this.jezik;
          this.camoti[this.izbranKljuc].email = this.email;
          this.izbranUporabnik = null;
          this.ime = null;
          this.priimek = null;
          this.tel = null;
          this.jezik = null;
          this.email = null;
          this.pGeslo = null;
          this.geslo = null;
          this.sGesla = false;
        }).catch((napaka) => {
          this.posodabljam = false;
          if (napaka !== undefined && napaka.response.data.napaka !== null) {
            this.text = napaka.response.data.napaka;
            this.types = "Napaka";
            this.ShowNoti = true;
          } else {
            this.text = napaka;
            this.types = "Napaka";
            this.ShowNoti = true;
          }

        });
      } else {
        this.text = "Za posodabljanje zapisov morajo biti izpolnjena vsa polja.";
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    Dodaj() {
      this.vnos = true;
      if (this.ime !== '' && this.priimek !== '' && this.tel !== '' && this.geslo !== '' && this.pGeslo !== '' && this.email !== '') {
        if(this.pGeslo === this.geslo) {
          let podatki = new URLSearchParams();
          podatki.append('uID', this.izbranUporabnik);
          podatki.append('ime', this.ime);
          podatki.append('priimek', this.priimek);
          podatki.append('tel', this.tel);
          podatki.append('jezik', this.jezik);
          podatki.append('email', this.email);
          podatki.append('password', this.geslo)
          axios.post('./api/camo/uporabniki/dodaj/', podatki, {withCredentials: true}).then((response) => {
            this.vnos = false;
            this.novVnos = false;
            this.text = response.data.sporocilo;
            this.types = "Uspešno";
            this.ShowNoti = true;
            this.camoti.push({
                  id:response.data.id,
                  ime:this.ime,
                  priimek:this.priimek,
                  tel:this.tel,
                  jezik:this.jezik,
                  email:this.email
          });
            this.izbranUporabnik = null;
            this.ime = null;
            this.priimek = null;
            this.tel = null;
            this.jezik = null;
            this.email = null;
          }).catch((napaka) => {
            this.vnos = false;
            if (napaka !== undefined && napaka.response.data.napaka !== null) {
              this.text = napaka.response.data.napaka;
              this.types = "Napaka";
              this.ShowNoti = true;
            } else {
              this.text = napaka;
              this.types = "Napaka";
              this.ShowNoti = true;
            }

          });
        }else {
          this.text = "Gesli se ne ujemata. Preverite vnesena gesla.";
          this.types = "Napaka";
          this.ShowNoti = true;
        }

      } else {
        this.text = "Za posodabljanje zapisov morajo biti izpolnjena vsa polja.";
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    Cancel() {
      this.ShowNoti = false;
      this.izbranUporabnik = null;
      this.brisanje = false;
    },
    ZapriUrejanje() {
      this.izbranUporabnik = null;
      this.ime = null;
      this.priimek = null;
      this.tel = null;
      this.jezik = null;
      this.email = null;
    },
  },
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <main class="main-content" >
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="section-title">
            <h3>Upravljanje računov CAMO</h3>
          </div>
        </div>
        <div class="col-12 text-center mt-2 mb-2">
          <button class="users-modern-btn users-modern-btn-primary" @click="novVnos = true">
            <i class="fas fa-user-plus"></i>
            Dodaj uporabnika
          </button>
        </div>
        <div class="col-12 sticky">
          <div class="container">
            <input class="input border-1 rounded-4 p-2 fs-5" type="text" placeholder="vnesi ime ali priimek uporabnika" v-model="searchUser" /> <i class="fas fa-search iskalnik"></i><br/>
          </div>
        </div>
        <div class="w-100 text-center text-white" v-if="brisanje">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
            <!-- KARTICA CAMO UPORABNIKA -->
            <div
                class="user-card"
                v-for="(user, key) in FilterUporabnikov"
                :key="user.id"
                :class="{ 'user-card-editing': izbranUporabnik === user.id && !brisanje }"
            >

              <!-- GLAVA -->
              <div class="user-card-header">

                <div class="user-settings-info">

                  <div class="user-avatar">
                    <span>
                      {{ user.ime.charAt(0) }}{{ user.priimek.charAt(0) }}
                    </span>
                  </div>

                  <div class="user-details">
                    <h3>
                      {{ user.ime }} {{ user.priimek }}
                    </h3>

                  </div>

                </div>


                <!-- ACTIONS -->
                <div class="user-actions">

                  <!-- PREKLIČI -->
                  <button
                      v-if="izbranUporabnik === user.id && !brisanje"
                      class="user-action user-action-cancel"
                      title="Prekliči urejanje"
                      @click.prevent="ZapriUrejanje()"
                  >
                    <i class="fas fa-times"></i>
                  </button>

                  <!-- UREDI -->
                  <button
                      v-if="(izbranUporabnik == null || izbranUporabnik !== user.id) && !brisanje"
                      class="user-action user-action-edit"
                      title="Uredi uporabnika"
                      @click.prevent="UrediUporabnika(user.id)"
                  >
                    <i class="fas fa-pen"></i>
                  </button>

                  <!-- IZBRIŠI -->
                  <button
                      class="user-action user-action-delete"
                      title="Izbriši uporabnika"
                      @click.prevent="BrisiUporabnika(user.id)"
                      :disabled="brisanje"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>

                </div>

              </div>

              <!-- OBRAZEC ZA UREJANJE -->
              <div
                  class="user-card-content"
                  v-if="izbranUporabnik === user.id && !brisanje"
              >

                <div class="user-form-grid">

                  <!-- IME -->
                  <div class="modern-form-group">
                    <label class="user-modern-form-label">
                      Ime
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-user"></i>

                      <input
                          class="users-modern-form-input"
                          autocomplete="off"
                          type="text"
                          v-model="ime"
                          required
                      />
                    </div>
                  </div>

                  <!-- PRIIMEK -->
                  <div class="modern-form-group">
                    <label class="user-modern-form-label">
                      Priimek
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-user"></i>

                      <input
                          class="users-modern-form-input"
                          autocomplete="off"
                          type="text"
                          v-model="priimek"
                          required
                      />
                    </div>
                  </div>

                  <!-- TELEFON -->
                  <div class="modern-form-group">
                    <label class="user-modern-form-label">
                      Telefon
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-phone"></i>

                      <input
                          class="users-modern-form-input"
                          autocomplete="off"
                          type="text"
                          v-model="tel"
                          required
                      />
                    </div>
                  </div>

                  <!-- EMAIL -->
                  <div class="modern-form-group">
                    <label class="user-modern-form-label">
                      Email
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-at"></i>

                      <input
                          class="users-modern-form-input"
                          autocomplete="off"
                          type="text"
                          v-model="email"
                          required
                      />
                    </div>
                  </div>

                  <!-- JEZIK -->
                  <div class="modern-form-group">
                    <label class="user-modern-form-label">
                      Jezik vmesnika
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-language"></i>

                      <select
                          class="users-modern-form-input"
                          v-model="jezik"
                      >
                        <option value="sl">Slovenščina</option>
                        <option value="it">Italiano</option>
                        <option value="en">English</option>
                      </select>
                    </div>
                  </div>

                  <div class="modern-form-group">
                    <label class="user-modern-form-label">
                      Želite spremeniti geslo? <span class="text-warning">{{ sGesla ? 'Da' : 'Ne' }}</span>
                    </label>
                    <input
                        class=""
                        type="checkbox"
                        v-model="sGesla"
                    />
                  </div>
                  <!-- GESLO -->
                  <div class="modern-form-group" v-if="sGesla">
                    <label class="user-modern-form-label">
                      Geslo
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-user-lock"></i>

                      <input
                          class="users-modern-form-input"
                          autocomplete="off"
                          type="password"
                          v-model="geslo"
                          required
                      />
                    </div>
                  </div>
                  <div class="modern-form-group" v-if="sGesla">
                    <label class="user-modern-form-label">
                      Potrditev gesla
                    </label>

                    <div class="modern-input-group">
                      <i class="fas fa-user-lock"></i>

                      <input
                          class="users-modern-form-input"
                          autocomplete="off"
                          type="password"
                          v-model="pGeslo"
                          required
                      />
                    </div>
                  </div>

                </div>

                <!-- GUMBI -->
                <div class="users-modern-form-actions">

                  <button
                      class="users-modern-btn modern-btn-secondary"
                      @click.prevent="ZapriUrejanje()"
                  >
                    Prekliči
                  </button>

                  <button
                      class="users-modern-btn users-modern-btn-primary"
                      @click.prevent="Validate()"
                      :disabled="posodabljam"
                  >
                    <i class="fas fa-sync-alt" :class="{'fa-spin': posodabljam}"></i>
                    Posodobi
                  </button>

                </div>

              </div>

            </div>
        <!-- OBRAZEC ZA VNOS NOVEGA UPORABNIKA -->
        <div
            class="user-card-content mt-2"
            v-if="novVnos"
        >
          <h3 class="text-white"><i class="fas fa-user-plus"></i></h3>

          <div class="user-form-grid">

            <!-- IME -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Ime
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="ime"
                    required
                />
              </div>
            </div>

            <!-- PRIIMEK -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Priimek
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="priimek"
                    required
                />
              </div>
            </div>

            <!-- GESLO -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Geslo
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user-lock"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="password"
                    v-model="geslo"
                    required
                />
              </div>
            </div>
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Potrditev gesla
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user-lock"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="password"
                    v-model="pGeslo"
                    required
                />
              </div>
            </div>

            <!-- TELEFON -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Telefon
              </label>

              <div class="modern-input-group">
                <i class="fas fa-phone"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="tel"
                    required
                />
              </div>
            </div>

            <!-- EMAIL -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Email
              </label>

              <div class="modern-input-group">
                <i class="fas fa-at"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="email"
                    required
                />
              </div>
            </div>

            <!-- JEZIK -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Jezik vmesnika
              </label>

              <div class="modern-input-group">
                <i class="fas fa-language"></i>

                <select
                    class="users-modern-form-input"
                    v-model="jezik"
                >
                  <option value="sl">Slovenščina</option>
                  <option value="it">Italiano</option>
                  <option value="en">English</option>
                </select>
              </div>
            </div>

          </div>

          <!-- GUMBI -->
          <div class="users-modern-form-actions">

            <button
                class="users-modern-btn modern-btn-secondary"
                @click.prevent="novVnos = false"
            >
              Prekliči
            </button>

            <button
                class="users-modern-btn users-modern-btn-primary"
                @click.prevent="Dodaj()"
                :disabled="vnos"
            >
              <i class="fas fa-spin fa-spinner" v-if="vnos"></i>
              <i class="fas fa-user-plus"></i>
              Dodaj
            </button>

          </div>
        </div>
          </div>
    </main>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da='Brisi()' @ne='Cancel()' @closeNotification="Cancel()" />
  </Transition>
</template>
